// DateRangePicker.js
import { useState, useEffect } from "react";
import { Calendar } from "primereact/calendar";
import "./DateRangePicker.css";
import { useTranslation } from "../../contexts/TranslationContext";
import dayjs from "dayjs";
import { addLocale, locale } from 'primereact/api';
import Cookies from 'js-cookie';

addLocale('ar', {
  firstDayOfWeek: 0, // Sunday
  dayNames: ['الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'],
  dayNamesShort: ['أحد', 'اثن', 'ثلا', 'أرب', 'خمي', 'جمع', 'سبت'],
  dayNamesMin: ['ح', 'ن', 'ث', 'ر', 'خ', 'ج', 'س'],
  monthNames: [
    'يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو',
    'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'
  ],
  monthNamesShort: [
    'يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو',
    'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'
  ],
//   monthNamesShort: [
//     'ينا', 'فبر', 'مار', 'أبر', 'ماي', 'يون',
//     'يول', 'أغس', 'سبت', 'أكت', 'نوف', 'ديس'
//   ],
  today: 'اليوم',
  clear: 'مسح',
  now: 'الاَن',
  dateFormat: 'dd/mm/yy',
  weekHeader: 'أسبوع'
});


const DateRangePicker = ({ value, onChange, arrow = false, min }) => {
  const [isCalendarVisible, setCalendarVisible] = useState(false);
  const [internalValue, setInternalValue] = useState(value);
  const { t } = useTranslation();
  const Lang = Cookies.get('preferred_language') || 'en';
  
  locale(Lang === 'ar' ? 'ar' : 'en');

  const handleDateChange = (e) => {
    const dates = e.value;
    setInternalValue(dates);

    // Only update parent when both dates are selected
    if (dates && dates[1]) {
      onChange({
        startDate: dayjs(dates[0]).format("YYYY-MM-DD"),
        endDate: dayjs(dates[1]).format("YYYY-MM-DD"),
      });
      setCalendarVisible(false);
    }
  };

  useEffect(() => {
    if (value?.startDate && value?.endDate) {
      const start = new Date(value.startDate);
      const end = new Date(value.endDate);
      setInternalValue([start, end]);
    } else {
      setInternalValue(null);
    }
  }, [value]);

  return (
    <div className="custom-range-picker">
      <div className="date-inputs">
        <input
          type="text"
          placeholder={t("StartDate")}
          value={internalValue?.[0]?.toLocaleDateString() || ""}
          readOnly
          onClick={() => setCalendarVisible(true)}
        />
        {arrow ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="26"
            height="12"
            viewBox="0 0 26 12"
            fill="none"
          >
            <path
              d="M25.5353 6.53033C25.8282 6.23744 25.8282 5.76256 25.5353 5.46967L20.7624 0.696699C20.4695 0.403806 19.9946 0.403806 19.7017 0.696699C19.4088 0.989593 19.4088 1.46447 19.7017 1.75736L23.9443 6L19.7017 10.2426C19.4088 10.5355 19.4088 11.0104 19.7017 11.3033C19.9946 11.5962 20.4695 11.5962 20.7624 11.3033L25.5353 6.53033ZM0 6.75H25.005V5.25H0V6.75Z"
              fill="#D5D5D5"
            />
          </svg>
        ) : (
          <span>{t("To")}</span>
        )}

        <input
          type="text"
          placeholder={t("EndDate")}
          value={internalValue?.[1]?.toLocaleDateString() || ""}
          readOnly
          onClick={() => setCalendarVisible(true)}
        />
      </div>

      {isCalendarVisible && (
        <div className="calendar-popup">
          <Calendar
            locale={Lang === 'ar' ? 'ar' : 'en'}
            dir={Lang === 'ar' ? 'rtl' : 'ltr'}
            value={internalValue}
            onChange={handleDateChange}
            selectionMode="range"
            numberOfMonths={2}
            readOnlyInput
            hideOnRangeSelection={false}
            onHide={() => setCalendarVisible(false)}
            minDate={min ?? null}
            autoFocus
          />
        </div>
      )}
    </div>
  );
};

export default DateRangePicker;
